






































import type { AnexoDosProcessos } from '@/models/anexo/AnexoDosProcessos'
import { downloadFilesFromS3 } from '@/shareds/s3/files'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class BotaoDeDownloadDeAnexo extends Vue {
	@Prop({ default: () => [] }) anexos!: AnexoDosProcessos[]

	baixandoAnexos = false
	baixandoArquivo: string[] = []

	get listaAnexos() {
		return this.anexos.reduce((acc, anexo) => acc.concat(anexo.urlDosArquivos), [] as string[])
	}

	async baixarArquivo(caminhoDaPasta: string, nomeDoArquivo: string) {
		this.baixandoArquivo.push(nomeDoArquivo)
		try {
			const pattern = /[~`!@#$%^&*()áÁàÀ\-+={}[\]|\\;:'",<>/?]+/g;
			if (pattern.test(nomeDoArquivo)) {
				AlertModule.setInfo("Parece que o arquivo salvo continha espaços e/ou caracteres especiais. O arquivo anexado poderá estar corrompido. Nesses casos, será necessário anexar o arquivo novamente!")
			}
			await downloadFilesFromS3(caminhoDaPasta, nomeDoArquivo)
			this.baixandoArquivo = this.baixandoArquivo.filter(nome => nomeDoArquivo !== nome)
		} catch (error: any) {
			AlertModule.setError('Houve um problema ao baixar o arquivo')
		} finally {
			this.baixandoArquivo = this.baixandoArquivo.filter(nome => nome !== nomeDoArquivo)
		}
	}

	extrairNomeDosDocumentos(url: string) {
		const lastSlashIndex = url.lastIndexOf("/")
		return url.substring(lastSlashIndex + 1)
	}

	extrairCaminho(url: string) {
		return url.replace(/.*\/(.+?\/[^/]+\/[^/]+)\/[^/]+$/, "$1")
	}
}
